export const COGNITIVE_MODES = [
  { id: "balanced", short: "Balanced", label: "Balanced Hybrid", color: "#10B981" },
  { id: "analytical", short: "Analytical", label: "Analytical / Bayesian", color: "#00F0FF" },
  { id: "associative", short: "Associative", label: "Associative / Hebbian", color: "#FF9F1C" },
  { id: "research", short: "Research", label: "Research / Deep Synthesis", color: "#8B5CF6" },
];
